import React from 'react'
import type { User } from '@paintscout/api'
import { EstimatorAvatarSelect, useUsers } from '@paintscout/ui'
import { getHighestRoleName } from '@paintscout/util'
import { useLocation } from 'react-router-dom'

export interface CalendarEstimatorSelectProps {
  selectedUsers: User[]
  tab: 'calendar' | 'map' | 'schedule'
  onClick: (user: User, e: React.MouseEvent) => void
  onDoubleClick?: (allUsers: User[]) => void
  userFilter?: (user: User) => boolean
}

export default function CalendarEstimatorSelect({
  selectedUsers,
  tab,
  userFilter,
  onClick,
  onDoubleClick
}: CalendarEstimatorSelectProps) {
  const { users, userPictures } = useUsers()
  const location = useLocation()
  const activeUsers = (users || []).filter((user) => user.app_metadata?.active)
  const nonOfficeUsers = activeUsers.filter(
    (user) =>
      getHighestRoleName(user.app_metadata.roles) !== (location.pathname.includes('scheduling') ? 'Crew' : 'Office')
  )
  const filteredUsers = userFilter ? nonOfficeUsers.filter(userFilter) : nonOfficeUsers

  if (filteredUsers.length < 2) {
    return null
  }

  return (
    <EstimatorAvatarSelect
      users={filteredUsers}
      selectedUsers={selectedUsers}
      userPictures={userPictures}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      tab={tab}
    />
  )
}
